import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  STATE_LIST,
  CREATE_AGENCY_USER,
  UPDATE_AGENCY_USER,
  CHANGE_PASSWORD,
  LOOKUP_BY_EMAIL_FOR_AGENCY,
  DECRYPT_PASSWORD_URL,
} from "../../../constants/ApiPaths";
import {
  authHeader,
  authUserRole,
  getAlertToast,
} from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  Row,
  Col,
  Label,
  Input,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Button,
  InputGroup,
  InputGroupText,
  ButtonToggle,
} from "reactstrap";
import { NUMBER_REGEX } from "../../../constants/ValidationRegex";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import Iconawesomeeye from "../../../images/eye.svg";
import Iconionicmdeyeoff from "../../../images/eye-slash.svg";
import { getAdminUserId, getAgencyId } from "../../common/CommonFunctions";


function AgencyModal(props) {
  const {
    className,
    modal,
    toggleHelper,
    flag,
    formData,
    Count,
    setCount,
    resetFormData,
    emailDisabled,
    loading,
    setLoading,
    enqueueSnackbar,
    oldPassword,
  } = props;
  const [passwordShown, setPasswordShown] = useState(false);
  const [lookupMail, setLookupMail] = useState("");

  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  useEffect(() => {
    getStateList();
  }, []);


  //validation schema
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        const num = v1.replace(/\D+/g, "");
        const check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        const Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email Required"),
    firstName: Yup.string().required("FirstName Required"),
    lastName: Yup.string().required("LastName Required"),

    phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    // city: Yup.string().required("city is Required"),
    // dateOfBirth: Yup.date()
    // .required("Date Of Birth Required")
    // .max(today, "Enter valid Date"),
    // address: Yup.string().required("Address is required"),
    // zip: Yup.string().required("Zip code is required"),
    zip: Yup.string()
      .matches(NUMBER_REGEX, "Zip is not valid")
      .max(6, "Zip is not valid")
      .required("Zip is required!"),
    // gender: Yup.string().required("Gender is required"),
    roleId: Yup.string().required("Role is required"),
    // stateId: Yup.string().required("State is required"),
  });
  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        // ps = response.data;
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangeFun = (e) => {
    setLookupMail(e.target.value);
  };
  //get State list
  const getStateList = async () => {
    const config = {
      method: "Get",
      url: STATE_LIST,
      data: formData,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  //Use Formik
  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    setValues,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => EmployeeEdit(values),
  });
  // const yupSchema = PhoneNumberschema();
  // const validationSc = Yup.object().shape(yupSchema);
  // //Employee actions

  const EmployeeEdit = async () => {
    setLoading(true);
    const configpass = {
      method: "PUT",
      url: CHANGE_PASSWORD,
      data: {
        oldPassword: oldPassword,
        newPassword: values.password,
        email: values.email,
        hyperlink: window.location.host,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(configpass);
      const { status } = response.data;

      if (status === "Success") {
        console.log("success");
      }
    } catch (error) {
      console.log(error);
    }
    values.stateId = null;
    const config = {
      method: flag ? "POST" : "PUT",
      url: flag ? CREATE_AGENCY_USER : UPDATE_AGENCY_USER,
      data: {
        ...values,
        createdBy: getAdminUserId(),
        agencyId: getAgencyId(),
        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status} = response.data;
      if (status === "Success") {
        setCount(Count + 1);
        resetFormData();
        toggleHelper(resetForm());
        Swal.fire(
          getAlertToast(
            "Success",
            flag ? "Create Successfully" : "Update Successfully"
          )
        );
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };



 
  const lookUpFun = async () => {
    if (lookupMail !== "") {
      //  setLoading(true);
      const config = {
        method: "GET",
        url: LOOKUP_BY_EMAIL_FOR_AGENCY,
        params: {
          email: lookupMail,
        },
      };
      try {
        const response = await API(config);
        const {
          address,
          city,
          dateOfBirth,
          email,
          firstName,
          gender,
          lastName,
          password,
          phoneNumber,
          stateId,
          zip,
          roleId,
        } = response.data.data[0];
        let decryptedPassword;
        if (password !== "") {
          decryptedPassword = await getDecrypted(password);
          setValues({ ...values, password: decryptedPassword });
        }
        setValues({
          firstName,
          lastName,
          email,
          password: decryptedPassword,
          phoneNumber,
          address,
          stateId,
          city,
          zip,
          roleId,
          dateOfBirth,
          gender,
        });
      } catch (error) {
        if (error) {
          const {  message } = error.response.data;
          CustomAlertMessage(message, "error", enqueueSnackbar);
        }
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      CustomAlertMessage("Please enter the email", "error", enqueueSnackbar);
    }
  };
  return (
    <div>
      {/* Modal Code */}
      <Modal
        isOpen={modal}
        size="lg"
        toggle={() => {
          toggleHelper();
          resetForm();
          setPasswordShown(false);
        }}
        className={className}
      >
        <Form form="true" onSubmit={handleSubmit}>
          <ModalHeader
            toggle={() => {
              toggleHelper();
              resetForm();
              setPasswordShown(false);
            }}
          >
            {flag ? "Create New Employee" : "Update Employee"}
          </ModalHeader>

          <ModalBody>
            <div className="user-box">
              {/* <img value={values.profileImage} src={Profile()} />
              <p>Employee Profile</p>

              <div className="upload-btn-wrapper">
                <button className="upload-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.407"
                    height="16.981"
                    viewBox="0 0 19.407 16.981"
                  >
                    <path
                      id="Icon_awesome-camera"
                      data-name="Icon awesome-camera"
                      d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                      transform="translate(0 -2.25)"
                      fill="#d51d1d"
                    />
                  </svg>
                </button>
                <Input
                  type="file"
                  name="profileImage"
                  onChange={profileChange}
                />
              </div> */}
            </div>
            {flag ? (
              <>
                <Row xs="12">
                  <Col xs="6">
                    <FormGroup>
                      <Label for="">Email</Label>
                      <Input
                        type="email"
                        value={lookupMail}
                        onBlur={handleBlur}
                        // disabled={Emaildisable}
                        // invalid={errors.email && touched.email ? true : false}
                        onChange={handleChangeFun}
                        id=""
                        placeholder="Enter email"
                      />
                      {/* <FormFeedback>
                    {errors.email && touched.email ? errors.email : ""}
                  </FormFeedback> */}
                    </FormGroup>
                  </Col>
                  <Col xs="6">
                    <ButtonToggle
                      style={{ marginTop: "30px" }}
                      // form={`endUserWebForm_${currentStep}`}
                      // type="submit"
                      color="primary"
                      onClick={lookUpFun}
                    >
                      {/* {loading && <CustomButtonLoader loading={loading} />} */}

                      {"Look Up"}
                    </ButtonToggle>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            <Row xs="12">
              <Col xs="6">
                <FormGroup>
                  <Label for="firstName">First name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    value={values.firstName}
                    onBlur={handleBlur}
                    invalid={
                      touched.firstName && errors.firstName ? true : false
                    }
                    onChange={handleChange}
                    placeholder="Enter first name"
                  />
                  <FormFeedback>
                    {touched.firstName && errors.firstName}
                  </FormFeedback>
                </FormGroup>
                {/* Email */}
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    value={values.email}
                    onBlur={handleBlur}
                    invalid={touched.email && errors.email ? true : false}
                    onChange={handleChange}
                    placeholder="Enter email"
                    disabled={emailDisabled ? "loading" : flag ? false : true}
                  />
                  <FormFeedback>{touched.email && errors.email}</FormFeedback>
                </FormGroup>
                {/* Date of Bith */}
                {/* <FormGroup>
                  <Label for="dob">Date of Birth</Label>
                  <Input
                    type="date"
                    name="dateOfBirth"
                    id="dob"
                    value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
                    onBlur={handleBlur}
                    invalid={
                      touched.dateOfBirth && errors.dateOfBirth ? true : false
                    }
                    onChange={handleChange}
                    placeholder="Enter DOB"
                  />
                  <FormFeedback>
                    {touched.dateOfBirth && errors.dateOfBirth}
                  </FormFeedback>
                </FormGroup> */}
                {/* Address */}
                {/* <FormGroup>
                  <Label for="address">Address</Label>
                  <Input
                    type="text"
                    name="address"
                    id="address"
                    value={values.address}
                    onBlur={handleBlur}
                    invalid={touched.address && errors.address ? true : false}
                    onChange={handleChange}
                    placeholder="Enter your address"
                  />
                  <FormFeedback>
                    {touched.address && errors.address}
                  </FormFeedback>
                </FormGroup> */}
                {/* Zip */}
                <FormGroup>
                  <Label for="zip">Zip</Label>
                  <Input
                    type="text"
                    name="zip"
                    id="zip"
                    value={values.zip}
                    onBlur={handleBlur}
                    invalid={touched.zip && errors.zip ? true : false}
                    onChange={handleChange}
                    placeholder="Enter zip"
                  />
                  <FormFeedback>{touched.zip && errors.zip}</FormFeedback>
                </FormGroup>
              </Col>

              {/* Last name*/}
              <Col xs="6">
                <FormGroup>
                  <Label for="lastName">Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={values.lastName}
                    onBlur={handleBlur}
                    invalid={touched.lastName && errors.lastName ? true : false}
                    onChange={handleChange}
                    placeholder="Enter your lastname"
                  />
                  <FormFeedback>
                    {touched.lastName && errors.lastName}
                  </FormFeedback>
                </FormGroup>
                {/* {!flag ? ( */}
                  <FormGroup>
                    <Label for="">Password</Label>
                    <InputGroup>
                      <Input
                        type={passwordShown ? "text" : "password"}
                        name="password"
                        value={values.password}
                        onBlur={handleBlur}
                        invalid={
                          errors.password && touched.password ? true : false
                        }
                        onChange={handleChange}
                        id=""
                        placeholder="Enter password"
                      />
                      <>
                        <InputGroupText
                          onClick={togglePassword}
                          style={{ cursor: "pointer" }}
                        >
                          {passwordShown ? (
                            <img src={Iconawesomeeye} alt=""/>
                          ) : (
                            <img src={Iconionicmdeyeoff} alt=""/>
                          )}
                        </InputGroupText>
                      </>
                    </InputGroup>
                    <FormFeedback>
                      {errors.email && touched.email ? errors.email : ""}
                    </FormFeedback>
                  </FormGroup>
                {/* ) : (
                  <></>
                )} */}
                {/* phone number */}
                <FormGroup>
                  <Label for="phoneNumber">Phone number</Label>
                  <Input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    value={values.phoneNumber}
                    onBlur={handleBlur}
                    invalid={
                      touched.phoneNumber && errors.phoneNumber ? true : false
                    }
                    onChange={handleChange}
                    placeholder="Enter phone number"
                  />
                  <FormFeedback>
                    {touched.phoneNumber && errors.phoneNumber}
                  </FormFeedback>
                </FormGroup>

                {/* gender */}
                {/* <FormGroup>
                  <Label for="gender">Gender</Label>
                  <Input
                    type="select"
                    name="gender"
                    id="geneder"
                    value={values.gender}
                    onBlur={handleBlur}
                    invalid={touched.gender && errors.gender ? true : false}
                    onChange={handleChange}
                    placeholder="Enter your gender"
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </Input>
                  <FormFeedback>{touched.gender && errors.gender}</FormFeedback>
                </FormGroup> */}
                {/* Role */}
                {flag ? (
                  <FormGroup>
                    <Label for="exampleSelect">Role</Label>
                    <Input
                      type="select"
                      name="roleId"
                      value={values.roleId}
                      invalid={touched.roleId && errors.roleId ? true : false}
                      onChange={handleChange}
                      id="exampleSelect"
                      placeholder="Enter your role"
                    >
                      <option value="">Select Role</option>
                      {authUserRole() === "Agency Admin" && (
                        <option value="3">Agency Admin</option>
                      )}
                      <option value="4">Agency Employee</option>
                    </Input>
                    <FormFeedback>
                      {touched.roleId && errors.roleId}
                    </FormFeedback>
                  </FormGroup>
                ) : (
                  ""
                )}
                {/* city */}
                {/* <FormGroup>
                  <Label for="city">City</Label>
                  <Input
                    type="text"
                    name="city"
                    id="city"
                    value={values.city}
                    onBlur={handleBlur}
                    invalid={touched.city && errors.city ? true : false}
                    onChange={handleChange}
                    placeholder="Enter city name"
                  />
                  <FormFeedback>{touched.city && errors.city}</FormFeedback>
                </FormGroup> */}

                {/* state */}
                {/* <FormGroup>
                  <Label for="state">State</Label>
                  <Input
                    type="select"
                    name="stateId"
                    value={values.stateId}
                    onBlur={handleBlur}
                    invalid={touched.stateId && errors.stateId ? true : false}
                    onChange={handleChange}
                    id="state"
                    placeholder="Enter state name"
                  >
                    <option value="">Select State</option>
                    {selectState.map((data) => {
                      const { stateId, stateName } = data;
                      return <option value={stateId}>{stateName}</option>;
                    })}
                  </Input>
                  <FormFeedback>
                    {touched.stateId && errors.stateId}
                  </FormFeedback>
                </FormGroup> */}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" block>
              {loading && <CustomButtonLoader />}
              {flag ? "ADD" : "Update"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}

export default AgencyModal;
